import { ZuiBaseElement } from '@zywave/zui-base';
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import './zui-spinner.js';
import { style } from './zui-spinner-overlay-css.js';

/**
 *  Use when a colored overlay to cover content, with a spinner graphic is needed.
 *
 * @element zui-spinner-overlay
 *
 * @slot loading-text - Slot for optional text to supplement beneath the spinner
 *
 * @cssprop [--zui-spinner-overlay-color=#fff] - Overlay fill color
 * @cssprop [--zui-spinner-overlay-opacity=1] - Opacity for overlay
 * @cssprop [--zui-spinner-overlay-transition=0.5s] - CSS length of time for rotating circle transition
 */

export class ZuiSpinnerOverlayElement extends ZuiBaseElement {
  /**
   * Set to true to show spinner
   */
  @property({ type: Boolean, reflect: true })
  active = false;

  /**
   * Alt text for better accessibility while spinner is present
   */
  @property({ type: String, reflect: true })
  alt = 'active';

  static get styles() {
    return [super.styles, style];
  }

  render() {
    return html`
      <div class="spinner-overlay">
        <zui-spinner class="spinner" ?active=${this.active} alt=${this.alt}></zui-spinner
        ><slot name="loading-text"></slot
      ></div>
    `;
  }
}

customElements.define('zui-spinner-overlay', ZuiSpinnerOverlayElement);
